<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-slot:navbarname>
        <b-link
            :to="{name:'Jobs'}"
            class="btn btn-primary btn-round">
          back
        </b-link>
      </template>
    </navbar>

    <b-card>
      <template v-if="job.status === 'not_accept'">
        <b-button
            @click="updateStatus('accept')"
            variant="success">{{ $t('accept') }}
        </b-button>
        <b-button @click="updateStatus('not_accept')"
                  variant="danger">delete
        </b-button>
      </template>
      <template v-else-if="job.status === 'accept'">
        <b-button
            disabled
            variant="success">
          accepted
        </b-button>
      </template>
    </b-card>


    <b-card title="Information">
      <b-alert show v-if="job.status === 'not_accept'" type="warning">
        <p class="mb-0">Bitte überprüfen Sie die Anfrage</p>
      </b-alert>
      <b-alert show v-else type="success">
        <p class="mb-0">Anfrage erfolgreich genehmigt</p>
      </b-alert>

      <!--START branch form-->
      <template v-if="job.job_type_form === 'franchise'">
        <ul class="list-group">
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Job type
            <span class="badge badge-pill">{{ jobType }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Name
            <span class="badge badge-pill">{{ job.name }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            E-Mail-Adresse
            <span class="badge badge-pill">{{ job.email }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Lebenslauf
            <span class="badge badge-pill">
              <a :href="job.cv_file_url">{{ job.cv_file_url }}</a>
            </span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Standort
            <span class="badge badge-pill">{{ job.place }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Budget in €
            <span class="badge badge-pill">{{ job.budget }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Geplanter Eröffnungstermin
            <span class="badge badge-pill">{{ job.open_date }}</span>
          </li>

        </ul>


        <h3 class="mt-4">Standort Details</h3>
        <div v-html="job.place_details"></div>

        <h3 class="mt-4">Immobilie</h3>
        <div v-html="job.additional_description"></div>

        <h3 class="mt-4">Erfahrung</h3>
        <div v-html="job.experience"></div>

        <h3 class="mt-4">Größe des Teams</h3>
        <div v-html="job.team_size"></div>
      </template>
      <!--END branch form-->

      <template v-else>
        <ul class="list-group">
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Job type
            <span class="badge badge-pill">{{ jobType }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Frima
            <span class="badge badge-pill">{{ job.company_name }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Ansprechpartner
            <span class="badge badge-pill">{{ job.name }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Straße & Hausnummer
            <span class="badge badge-pill">{{ job.street_house_number }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Plz
            <span class="badge badge-pill">{{ job.post_code }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Ort
            <span class="badge badge-pill">{{ job.place }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Telefon
            <span class="badge badge-pill">{{ job.telephone }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Fax
            <span class="badge badge-pill">{{ job.fax }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Email
            <span class="badge badge-pill">{{ job.email }}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Website
            <span class="badge badge-pill">{{ job.website }}</span>
          </li>

        </ul>

        <h3 class="mt-4">kommentar</h3>
        <div v-html="job.description"></div>

        <h3 class="mt-4">Firmenprofil</h3>
        <div v-html="job.description_work"></div>
      </template>


    </b-card>

  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'

export default {
  name: "Details",
  components: {Navbar},
  data() {
    return {
      job: {},
      jobType: null
    }
  },
  methods: {
    updateStatus(type) {
      if (this.$route.params.jobid && this.$route.params.jobid > 0) {
        this.$Progress.start();
        Http.post(Http.apiurl() + 'job/update/status/job/' + this.$route.params.jobid, {
          type: type
        })
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                if (type === 'not_accept') {
                  this.$router.push({name: 'Jobs'})
                } else {
                  this.getJobDetails();
                }
                Notification.success(response.data.message)
              } else {
                Notification.error(response.data.message)

              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }
    },
    getJobDetails() {
      if (this.$route.params.jobid && this.$route.params.jobid > 0) {
        this.$Progress.start();
        Http.get(Http.apiurl() + 'job/show/request/' + this.$route.params.jobid)
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.job = response.data.data.job;
                this.jobType = response.data.data.additional.job_title;
              } else {
                Notification.error(response.data.message)

              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }
    }
  },
  created() {
    this.getJobDetails();
  }
}
</script>

<style scoped>

</style>